export const googleAnalytics = {
  title: "Google Analytics",
  description:
    "Connect your Google Analytics Tracking ID to measure traffic and customer behavior in your store.",
  trackingIdLabel: "Tracking ID",
  trackingIdPlaceholder: "E.g. G-XXXXXXXXXX",
  findId: "How do I find my ID?",
  save: "Update",
  saving: "Saving...",
  saveSuccess: "Google Analytics code updated successfully",
  saveError: "Could not update the Google Analytics code",
  helpWhatsapp:
    "Hi, I need help with the Google Analytics add-on in Domun.",
  acquire: {
    title: "Activate Google Analytics",
    description:
      "Power your business with accurate data about your customers' behavior.",
    cta: "Get add-on",
  },
  findIdScreen: {
    title: "Find ID",
    stepLabel: "Step {{step}} of {{maxStep}}",
    gotIt: "Got it",
    openAnalytics: "Go to Google Analytics",
    steps: [
      {
        name: "Open Google Analytics",
        description:
          "Sign in to Google Analytics and select your store property.",
      },
      {
        name: "Go to settings",
        description:
          "In Admin, open the property settings or the web data stream.",
      },
      {
        name: "Copy your Tracking ID",
        description:
          "Copy the measurement ID (G-XXXXXXXX format) and paste it in Domun.",
      },
    ],
  },
};
